import { SET_PREFERRED_PARTNER } from 'actions';
import { IPartner } from 'typings';

export const setPreferredPartner = (preferredPartner?: IPartner) => {
  return { preferredPartner, type: SET_PREFERRED_PARTNER };
};
